import { render } from "./ViewLoader.vue?vue&type=template&id=7319a7b3"
import script from "./ViewLoader.vue?vue&type=script&lang=js"
export * from "./ViewLoader.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__